module.exports = __webpack_public_path__ + "img/bio.6868274f.png";